module.exports = __webpack_public_path__ + "img/Komisaris-Independent-Ricky-Avicenna.e900c05c.jpg";